import { i18n } from "@lingui/core";
import type { AppLocale } from "./locales";

type CatalogModule = { messages: Record<string, string> };

const catalogLoaders: Record<AppLocale, () => Promise<CatalogModule>> = {
  en: () => import("../locales/en.po"),
  fr: () => import("../locales/fr.po"),
};

export async function activateLocale(locale: AppLocale) {
  const mod = await catalogLoaders[locale]();
  i18n.load(locale, mod.messages);
  i18n.activate(locale);
}

export { i18n };
